module.exports = __webpack_public_path__ + "fonts/Myriad-Pro-Bold.5468e8ae.ttf";